import styled from 'styled-components'

import { Color } from 'root-constants'

import { FlowTitle } from '../../styles'

export const StyledFlowPauseSubscription = {
  Description: styled.p`
    margin-bottom: 24px;
    color: ${Color.BLUE_DARK};
    font-size: 17px;
    font-weight: 400;
    line-height: 26px;
  `,
  Title: styled(FlowTitle)`
    margin-bottom: 24px;
    font-size: 24px;
    line-height: 32px;
  `,
}
